import React, {
  useMemo,
  useState,
} from "react";

import {
  Route,
  Redirect,
} from "react-router-dom";

import usePlatformAuth from
  "../hooks/usePlatformAuth";

import PlatformLayout from
  "../components/dashboard/components/platformComponent/PlatformLayout";

import {
  PlatformLayoutProvider,
} from "../components/ContextApi/PlatformLayoutContext";


const PlatformAuthGuard = ({
  component:
    Component,

  title:
    defaultTitle =
      "",

  description:
    defaultDescription =
      "",

  ...rest
}) => {

  const {
    platformLoading,

    isPlatformAuthenticated,

    platformUser,
  } =
    usePlatformAuth();


  /*
  |--------------------------------------------------------------------------
  | PAGE HEADER STATE
  |--------------------------------------------------------------------------
  */

  const [
    pageHeader,
    setPageHeader,
  ] =
    useState({
      title:
        defaultTitle,

      description:
        defaultDescription,

      headerActions:
        null,
    });


  /*
  |--------------------------------------------------------------------------
  | UPDATE HEADER
  |--------------------------------------------------------------------------
  */

  const setPlatformHeader =
    (
      header = {}
    ) => {

      setPageHeader(
        (
          previous
        ) => ({
          ...previous,

          ...header,
        })
      );

    };


  /*
  |--------------------------------------------------------------------------
  | RESET HEADER
  |--------------------------------------------------------------------------
  */

  const resetPlatformHeader =
    () => {

      setPageHeader({
        title:
          defaultTitle,

        description:
          defaultDescription,

        headerActions:
          null,
      });

    };


  /*
  |--------------------------------------------------------------------------
  | CONTEXT
  |--------------------------------------------------------------------------
  */

  const layoutContextValue =
    useMemo(
      () => ({
        setPlatformHeader,

        resetPlatformHeader,
      }),
      [
        defaultTitle,
        defaultDescription,
      ]
    );


  return (
    <Route
      {...rest}
      render={
        (
          props
        ) => {

          /*
          |--------------------------------------------------------------------------
          | LOADING
          |--------------------------------------------------------------------------
          */

          if (
            platformLoading
          ) {

            return (
              <div
                style={{
                  minHeight:
                    "100vh",

                  display:
                    "flex",

                  alignItems:
                    "center",

                  justifyContent:
                    "center",
                }}
              >
                Loading Platform...
              </div>
            );

          }


          /*
          |--------------------------------------------------------------------------
          | NOT LOGGED IN
          |--------------------------------------------------------------------------
          */

          if (
            !isPlatformAuthenticated
          ) {

            return (
              <Redirect
                to="/platform/login"
              />
            );

          }


          /*
          |--------------------------------------------------------------------------
          | ROLE CHECK
          |--------------------------------------------------------------------------
          */

          if (
            String(
              platformUser
                ?.role ||
              ""
            )
              .trim()
              .toUpperCase() !==
            "PLATFORM_SUPER_ADMIN"
          ) {

            return (
              <Redirect
                to="/platform/login"
              />
            );

          }


          /*
          |--------------------------------------------------------------------------
          | PLATFORM PAGE
          |--------------------------------------------------------------------------
          */

          return (
            <PlatformLayoutProvider
              value={
                layoutContextValue
              }
            >

              <PlatformLayout
                title={
                  pageHeader.title
                }
                description={
                  pageHeader.description
                }
                headerActions={
                  pageHeader.headerActions
                }
              >

                <Component
                  {...props}
                />

              </PlatformLayout>

            </PlatformLayoutProvider>
          );

        }
      }
    />
  );
};


export default PlatformAuthGuard;